"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const PlayPause = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 25 25"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.16671 7.5C8.70647 7.5 8.33337 7.8731 8.33337 8.33333V16.6667C8.33337 17.1269 8.70647 17.5 9.16671 17.5H10.8334C11.2936 17.5 11.6667 17.1269 11.6667 16.6667V8.33333C11.6667 7.8731 11.2936 7.5 10.8334 7.5H9.16671ZM14.1667 7.5C13.7065 7.5 13.3334 7.8731 13.3334 8.33333V16.6667C13.3334 17.1269 13.7065 17.5 14.1667 17.5H15.8334C16.2936 17.5 16.6667 17.1269 16.6667 16.6667V8.33333C16.6667 7.8731 16.2936 7.5 15.8334 7.5H14.1667Z",
  className: "fill"
}));
var _default = exports.default = PlayPause;